<header class="site-header" [class.scrolled]="scrolled">
  <!-- ───── Row 1 – logo + hamburger / CTAs ───── -->
  <div class="top-bar">
    <a routerLink="/" class="logo" aria-label="Heattech home">
      <img src="/images/logo.png" alt="Heattech Plumbing & Heating logo" />
    </a>

    <!-- 📱 Hamburger – shown only under 768 px -->
    <button
      type="button"
      class="menu-toggle"
      aria-label="Toggle navigation"
      (click)="toggleMobileNav()"
    >
      <!-- three lines; you can swap for an <svg> -->
      <span></span><span></span><span></span>
    </button>

    <!-- desktop CTAs -->
    <div class="actions desktop-only">
      <button type="button" class="whatsapp" (click)="whatsappNow()">
        Whatsapp Us
      </button>
      <button type="button" class="call-now" (click)="callNow()">
        Call Us
      </button>
      <button type="button" class="book-now" (click)="bookNow()">
        Book Now
      </button>
    </div>
  </div>

  <!-- Row 2 – full-width primary nav -->
  <nav class="main-nav desktop-only" aria-label="Primary navigation">
    <ul>
      <li>
        <a
          routerLink="/home"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Home</a
        >
      </li>

      <!-- Heating -->
      <li
        class="dropdown"
        (mouseenter)="setDropdown('heating', true)"
        (mouseleave)="setDropdown('heating', false)"
      >
        <button
          type="button"
          aria-haspopup="true"
          [attr.aria-expanded]="isOpen('heating')"
        >
          Heating ▾
        </button>

        <ul class="submenu" [class.open]="isOpen('heating')">
          <li>
            <a [routerLink]="['/services']" fragment="boiler-installations"
              >Boiler Installations</a
            >
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="heat-pumps">Heat Pumps</a>
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="heating-controls"
              >Heating Controls</a
            >
          </li>
        </ul>
      </li>

      <!-- Plumbing -->
      <li
        class="dropdown"
        (mouseenter)="setDropdown('plumbing', true)"
        (mouseleave)="setDropdown('plumbing', false)"
      >
        <button
          type="button"
          aria-haspopup="true"
          [attr.aria-expanded]="isOpen('plumbing')"
        >
          Plumbing ▾
        </button>

        <ul class="submenu" [class.open]="isOpen('plumbing')">
          <li>
            <a [routerLink]="['/services']" fragment="general-plumbing"
              >General Plumbing</a
            >
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="bathroom-renovations"
              >Bathroom Renovations</a
            >
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="leak-repairs"
              >Leak Repairs</a
            >
          </li>
        </ul>
      </li>

      <!-- Commercial -->
      <li
        class="dropdown"
        (mouseenter)="setDropdown('commercial', true)"
        (mouseleave)="setDropdown('commercial', false)"
      >
        <button
          type="button"
          aria-haspopup="true"
          [attr.aria-expanded]="isOpen('commercial')"
        >
          Commercial ▾
        </button>

        <ul class="submenu" [class.open]="isOpen('commercial')">
          <li>
            <a [routerLink]="['/services']" fragment="commercial-boilers"
              >Commercial Boilers</a
            >
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="'plantroom-installations"
              >Plant Room Installations</a
            >
          </li>
          <li>
            <a [routerLink]="['/services']" fragment="maintenance-contracts"
              >Maintenance Contracts</a
            >
          </li>
        </ul>
      </li>

      <li>
        <a routerLink="/about-us" routerLinkActive="active">About&nbsp;Us</a>
      </li>
      <li>
        <a routerLink="/contact" routerLinkActive="active">Contact&nbsp;Us</a>
      </li>
    </ul>
  </nav>

  <!-- ───── Mobile full-screen panel ───── -->
  <div class="mobile-nav" [class.open]="mobileOpen" (click)="toggleMobileNav()">
    <nav aria-label="Mobile navigation" (click)="$event.stopPropagation()">
      <ul>
        <li>
          <a routerLink="/home" (click)="toggleMobileNav()">Home</a>
        </li>

        <!-- Heating -->
        <li class="dropdown">
          <button type="button" (click)="toggleMobileDropdown('heating')">
            Heating ▾
          </button>

          <ul class="submenu" [class.open]="isMobileOpen('heating')">
            <li>
              <a
                [routerLink]="['/services']"
                fragment="boiler-installations"
                (click)="toggleMobileNav()"
                >Boiler Installations</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="heat-pumps"
                (click)="toggleMobileNav()"
                >Heat Pumps</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="heating-controls"
                (click)="toggleMobileNav()"
                >Heating Controls</a
              >
            </li>
          </ul>
        </li>

        <!-- Plumbing -->
        <li class="dropdown">
          <button type="button" (click)="toggleMobileDropdown('plumbing')">
            Plumbing ▾
          </button>

          <ul class="submenu" [class.open]="isMobileOpen('plumbing')">
            <li>
              <a
                [routerLink]="['/services']"
                fragment="general-plumbing"
                (click)="toggleMobileNav()"
                >General Plumbing</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="bathroom-renovations"
                (click)="toggleMobileNav()"
                >Bathroom Renovations</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="leak-repairs"
                (click)="toggleMobileNav()"
                >Leak Repairs</a
              >
            </li>
          </ul>
        </li>

        <!-- Commercial -->
        <li class="dropdown">
          <button type="button" (click)="toggleMobileDropdown('commercial')">
            Commercial ▾
          </button>

          <ul class="submenu" [class.open]="isMobileOpen('commercial')">
            <li>
              <a
                [routerLink]="['/services']"
                fragment="commercial-boilers"
                (click)="toggleMobileNav()"
                >Commercial Boilers</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="'plantroom-installations"
                (click)="toggleMobileNav()"
                >Plant Room Installations</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/services']"
                fragment="maintenance-contracts"
                (click)="toggleMobileNav()"
                >Maintenance Contracts</a
              >
            </li>
          </ul>
        </li>

        <li>
          <a routerLink="/about-us" (click)="toggleMobileNav()">About Us</a>
        </li>
        <li>
          <a routerLink="/contact" (click)="toggleMobileNav()">Contact Us</a>
        </li>

        <!-- Mobile CTAs -->
        <li class="cta-row">
          <button type="button" class="whatsapp" (click)="whatsappNow()">
            Whatsapp Us
          </button>
          <button class="call-now" (click)="callNow()">Call Now</button>
          <button class="book-now" (click)="bookNow()">Book Now</button>
        </li>
      </ul>
    </nav>
  </div>
</header>

<router-outlet />

<axis-footer
  [contactTitle]="footerData.contactTitle"
  [contactSubtitle]="footerData.contactSubtitle"
  [contactNumber]="footerData.contactNumber"
  [buttonLink]="footerData.buttonLink"
  [gridColumns]="footerData.gridColumns"
  [columns]="footerData.columns"
  [socialLinks]="footerData.socialLinks"
>
</axis-footer>

<!-- TEST PUSH -->
